import { START_LOADING, END_LOADING } from "./loading_actions";
import { postResetPassword } from "../../utils/api";
import { SET_PORTAL_API } from "./portal_actions";
import {
  TITLE_NOTIFICATION, TITLE_ERROR, FORGOT_PASSWORD_SUCCESS
} from "../../utils/constants";

export const EDIT_EMAIL_FORGOT = 'EDIT_EMAIL_FORGOT';
export const RESET_FORGOT_FORM = 'RESET_FORGOT_FORM';
export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const REQUEST_RESET_PASSWORD_SUCCESS = 'REQUEST_RESET_PASSWORD_SUCCESS';
export const REQUEST_RESET_PASSWORD_FAILED = 'REQUEST_RESET_PASSWORD_FAILED';


export const postResetPasswordThunk = (email, navigate) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_RESET_PASSWORD });
    postResetPassword(email)
      .then(data => {
        dispatch({ type: REQUEST_RESET_PASSWORD_SUCCESS });
        dispatch({ type: RESET_FORGOT_FORM });
        navigate("/", { replace: true });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: FORGOT_PASSWORD_SUCCESS
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({ type: REQUEST_RESET_PASSWORD_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      })
  }
}
